<template>
  <div class="user">
    <self-title :title="titles" :fixed="true" @titleClick="titleClick"></self-title>
    <transition name="slide-fade">
      <div v-permissions="'customer:query'" class="main-page" v-show="web == 'main'">
        <div class="title">客户中心</div>
        <el-form
          class="search-form"
          ref="searchForm"
          :model="searchForm"
          label-width="100px"
          @submit.native.prevent="false"
        >
          <el-row>
            <el-col :xs="12" :sm="8">
              <el-form-item label="公司名称" class="name">
                <!-- <el-autocomplete
                  class="inline-input"
                  v-model="searchForm.name"
                  size="small"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                  @select="handleSelect"
                  @blur="search(1)"
                >
                  <template slot-scope="{ item }">
                    <div class="name">{{ item }}</div>
                  </template></el-autocomplete
                > -->
                <!-- <el-select
                  v-model="searchForm.name"
                  placeholder="请选择"
                  size="small"
                  filterable
                  clearable
                  @change="search(1)"
                >
                  <el-option :label="item" :value="item" v-for="(item, index) in companys" :key="'2-' + index">
                  </el-option>
                </el-select> -->
                <el-input
                  size="small"
                  v-model="searchForm.name"
                  placeholder="请输入公司名称"
                  clearable
                  @keyup.enter.native="search(1)"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="8">
              <el-form-item class="show-pc roleName" label="区域">
                <el-cascader
                  class="width-100"
                  v-model="searchForm.qy"
                  placeholder="请选择区域"
                  :options="options"
                  :props="{ checkStrictly: true }"
                  filterable
                  clearable
                  size="small"
                  @change="searchQyChange"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item class="show-phone roleName" label="区域">
                <el-row>
                  <el-col :span="8"
                    ><div @click="popup1ShowState = true">
                      <el-input v-model="searchForm.area1" size="small" :disabled="true"></el-input>
                    </div>
                  </el-col>
                  <el-col :span="8"
                    ><div @click="popup2ShowState = true">
                      <el-input v-model="searchForm.area2" size="small" :disabled="true"></el-input>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div @click="popup3ShowState = true">
                      <el-input v-model="searchForm.area3" size="small" :disabled="true"></el-input>
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="8">
              <el-form-item label="纳税性质" class="roleName">
                <el-select
                  v-model="searchForm.taxNature"
                  size="small"
                  placeholder="请选择"
                  clearable
                  @change="search(1)"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option :label="item.name" :value="item.name" v-for="(item, index) in taxs" :key="'1-' + index">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="6">
              <el-form-item label="客户经理" prop="accountManagerId">
                <el-select
                  v-model="searchForm.accountManagerId"
                  size="small"
                  placeholder="请选择"
                  clearable
                  @change="search(1)"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option :label="item.name" :value="item.id" v-for="(item, index) in persons" :key="'7-' + index">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="8">
              <el-form-item label="负责人" class="roleName">
                <el-select
                  class="width-100"
                  ref="selectMultiple"
                  v-model="searchForm.accountants"
                  multiple
                  placeholder="请选择"
                  size="small"
                  :disabled="userInfo.content_jurisdiction == '0'"
                  @change="accountantChange"
                >
                  <el-option-group
                    :disabled="
                      searchForm.accountants &&
                        searchForm.accountants.length > 0 &&
                        searchForm.accountants.indexOf('no') < 0
                    "
                  >
                    <el-option label="未分配" value="no"></el-option>
                  </el-option-group>
                  <el-option-group
                    :disabled="
                      searchForm.accountants &&
                        searchForm.accountants.length > 0 &&
                        searchForm.accountants.indexOf('no') >= 0
                    "
                  >
                    <el-option
                      v-show="
                        (userInfo.content_jurisdiction == '0' && userInfo.id === item.id) ||
                          userInfo.content_jurisdiction != '0'
                      "
                      :label="item.name"
                      :value="item.id"
                      v-for="(item, index) in persons"
                      :key="'8-' + index"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="10" class="show-pc">
              <el-form-item label="到期时间" class="roleName">
                <!-- <el-select
                  v-model="searchForm.lastFewDays"
                  size="small"
                  placeholder="请选择"
                  clearable
                  @change="search(1)"
                >
                  <el-option label="不限" value=""></el-option>
                  <el-option :label="item.name" :value="item.code" v-for="(item, index) in cycle2" :key="'4-' + index">
                  </el-option>
                </el-select> -->
                <el-date-picker
                  class="show-pc"
                  size="small"
                  v-model="searchForm.deadline"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd 00:00:00"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="deadlineChange"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="8" class="show-phone">
              <el-form-item label="到期时间" class="roleName">
                <el-row>
                  <el-col :span="12">
                    <el-date-picker
                      size="small"
                      v-model="searchForm.deadlineA"
                      type="date"
                      value-format="yyyy-MM-dd 00:00:00"
                      placeholder="开始日期"
                      @change="deadlineAchange"
                    ></el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <el-date-picker
                      size="small"
                      v-model="searchForm.deadlineB"
                      type="date"
                      value-format="yyyy-MM-dd 00:00:00"
                      placeholder="结束日期"
                      @change="deadlineBchange"
                    ></el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item class="btn">
            <el-button v-permissions="'customer:query'" type="primary" size="small" class="search" @click="search(1)"
              >查询
            </el-button>
            <el-button v-permissions="'customer:query'" type="warning" plain size="small" class="search" @click="reset"
              >清空筛选项
            </el-button>
            <el-button
              v-permissions="'customer:add'"
              type="primary"
              size="small"
              class="add"
              icon="el-icon-plus"
              @click="add"
              >新增客户</el-button
            >
            <button class="show-pc-inline import-btn el-button el-button--warning el-button--small">
              <i class="el-icon-upload"></i>
              导入客户
              <input type="file" class="import-excel" name="picJdcmp" ref="picJdcmp" @change="fileRead" />
            </button>
            <el-button
              v-permissions="'customer:exportExcel'"
              type="success"
              size="small"
              class="reset show-pc-inline"
              icon="el-icon-download"
              @click="exportCustomer"
              >导出客户
            </el-button>
            <el-button
              v-permissions="'customer:add'"
              type="text"
              size="small"
              class="show-pc-inline search"
              icon="el-icon-download"
              @click="downloadExcel"
              >导入客户模板下载
            </el-button>
          </el-form-item>
        </el-form>
        <div class="show-pc" v-if="userInfo.permissions.indexOf('customer:queryFee') >= 0">
          <el-table :data="tableData" height="60vh" style="width: 100%" @cell-click="cellClick">
            <el-table-column label="公司名称">
              <template slot-scope="scope">
                <span>{{ scope.row.customer.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="区域">
              <template slot-scope="scope">
                <span
                  >{{ scope.row.customer.area1 }}/{{ scope.row.customer.area2 }}/{{ scope.row.customer.area3 }}</span
                >
              </template>
            </el-table-column>
            <!-- <el-table-column label="法人">
              <template slot-scope="scope">
                <span>{{ scope.row.customer.legalPerson }}</span>
              </template>
            </el-table-column> -->
            <el-table-column label="纳税性质">
              <template slot-scope="scope">
                <span>{{ scope.row.customer.taxNature }}</span>
              </template>
            </el-table-column>
            <el-table-column label="客户经理">
              <template slot-scope="scope">
                <span>{{ scope.row.customer.accountManager }}</span>
              </template>
            </el-table-column>
            <el-table-column label="负责人">
              <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.customerAccountantList" :key="index">
                  <el-tag size="mini">{{ item.name }}</el-tag
                  >&nbsp;&nbsp;
                </span>
              </template>
            </el-table-column>
            <el-table-column label="收费项目" width="300px">
              <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.feeList" :key="index">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="
                      `${item.name}/${(item.payPeriodStart && item.payPeriodStart.substring(0, 10)) || ''} -
                      ${(item.payPeriodEnd && item.payPeriodEnd.substring(0, 10)) || ''}/￥${item.price}`
                    "
                    placement="left"
                  >
                    <el-tag size="mini"
                      >{{ item.name }}/{{ item.payPeriodStart && item.payPeriodStart.substring(0, 10) }} -
                      {{ item.payPeriodEnd && item.payPeriodEnd.substring(0, 10) }}/￥{{ item.price }}</el-tag
                    >
                  </el-tooltip>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150px">
              <template slot-scope="scope">
                <el-button
                  v-permissions="'customer:update'"
                  size="mini"
                  type="primary"
                  plain
                  @click="handleEdit(scope.$index, scope.row.customer)"
                  >编辑</el-button
                >
                <el-button
                  v-permissions="'customer:delete'"
                  size="mini"
                  plain
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row.customer)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <span class="text-warning">应收金额统计：{{ amount }}</span>
          <div class="page">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchForm.currentPage"
              :page-sizes="[100, 200, 500, 1000, 2000]"
              :page-size="searchForm.pageSize"
              layout="total, prev, pager, next, sizes, jumper"
              :total="searchForm.total"
            >
            </el-pagination>
          </div>
        </div>
        <div class="show-pc" v-if="userInfo.permissions.indexOf('customer:queryFee') < 0">
          <el-table :data="tableData" height="60vh" style="width: 100%" @cell-click="cellClick">
            <el-table-column label="公司名称">
              <template slot-scope="scope">
                <span>{{ scope.row.customer.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="区域">
              <template slot-scope="scope">
                <span
                  >{{ scope.row.customer.area1 }}/{{ scope.row.customer.area2 }}/{{ scope.row.customer.area3 }}</span
                >
              </template>
            </el-table-column>
            <!-- <el-table-column label="法人">
              <template slot-scope="scope">
                <span>{{ scope.row.customer.legalPerson }}</span>
              </template>
            </el-table-column> -->
            <el-table-column label="纳税性质">
              <template slot-scope="scope">
                <span>{{ scope.row.customer.taxNature }}</span>
              </template>
            </el-table-column>
            <el-table-column label="客户经理">
              <template slot-scope="scope">
                <span>{{ scope.row.customer.accountManager }}</span>
              </template>
            </el-table-column>
            <el-table-column label="负责人">
              <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.customerAccountantList" :key="index">
                  <el-tag size="mini">{{ item.name }}</el-tag
                  >&nbsp;&nbsp;
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150px">
              <template slot-scope="scope">
                <el-button
                  v-permissions="'customer:update'"
                  size="mini"
                  type="primary"
                  plain
                  @click="handleEdit(scope.$index, scope.row.customer)"
                  >编辑</el-button
                >
                <el-button
                  v-permissions="'customer:delete'"
                  size="mini"
                  plain
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row.customer)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <span class="text-warning">应收金额统计：{{ amount }}</span>
          <div class="page">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchForm.currentPage"
              :page-sizes="[100, 200, 500, 1000, 2000]"
              :page-size="searchForm.pageSize"
              layout="total, prev, pager, next, sizes, jumper"
              :total="searchForm.total"
            >
            </el-pagination>
          </div>
        </div>
        <div class="show-phone">
          <el-table :data="tableData" height="55vh" style="width: 100%" @cell-click="cellClick">
            <el-table-column label="公司名称">
              <template slot-scope="scope" @click="handleDetail(scope.$index, scope.row.customer)">
                <span>{{ scope.row.customer.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="客户经理">
              <template slot-scope="scope" @click="handleDetail(scope.$index, scope.row.customer)">
                <span>{{ scope.row.customer.accountManager }}</span>
              </template>
            </el-table-column>
            <el-table-column label="到期时间">
              <template slot-scope="scope" @click="handleDetail(scope.$index, scope.row.customer)">
                <span>{{
                  scope.row.customer.payPeriodEnd ? scope.row.customer.payPeriodEnd.substring(0, 10) : ''
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80px">
              <template slot-scope="scope">
                <el-button
                  v-permissions="'customer:update'"
                  size="mini"
                  type="primary"
                  plain
                  @click="handleEdit(scope.$index, scope.row.customer)"
                  >编辑</el-button
                >
                <p style="width: 60px;height:5px"></p>
                <el-button
                  v-permissions="'customer:delete'"
                  size="mini"
                  plain
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row.customer)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchForm.currentPage"
              :page-size="searchForm.pageSize"
              layout="total, prev, pager, next"
              :total="searchForm.total"
            >
            </el-pagination>
            <span class="text-warning">应收金额统计：{{ amount }}</span>
          </div>
          <!-- <el-upload
            class="upload-demo"
            ref="upload"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-change="handleChange"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            list-type="picture"
            :auto-upload="false"
          >
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload"
              >上传到服务器</el-button
            >
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload> -->
        </div>
        <!-- 分页器 -->
      </div>
    </transition>
    <transition name="slide-fade">
      <self-detail
        ref="detail"
        v-if="web == 'edit' || web == 'add' || web == 'detail'"
        :customer-id="addForm.id"
        :detail-data="addForm"
        :web-state="web"
        :detail-persons="persons"
        @cancel="cancel"
        @save="save"
      ></self-detail>
    </transition>
    <van-popup v-model="popup1ShowState" position="bottom" :style="{ height: '50%' }" :lazy-render="false">
      <van-picker
        ref="pickerQy"
        show-toolbar
        title="省"
        :columns="options1"
        @confirm="pickerConfirm1"
        @cancel="pickerCancel1"
      />
    </van-popup>
    <van-popup v-model="popup2ShowState" position="bottom" :style="{ height: '50%' }" :lazy-render="false">
      <van-picker
        ref="pickerQy"
        show-toolbar
        title="市"
        :columns="options2"
        @confirm="pickerConfirm2"
        @cancel="pickerCancel2"
      />
    </van-popup>
    <van-popup v-model="popup3ShowState" position="bottom" :style="{ height: '50%' }" :lazy-render="false">
      <van-picker
        ref="pickerQy"
        show-toolbar
        title="县/区"
        :columns="options3"
        @confirm="pickerConfirm3"
        @cancel="pickerCancel3"
      />
    </van-popup>
  </div>
</template>

<script>
import cityData from '../../utils/Data'
import SelfDetail from './components/Detail'
export default {
  name: 'Customer',
  components: {
    SelfDetail
  },
  data() {
    return {
      userInfo: {},
      titles: ['客户中心'],
      web: 'main',
      tableData: [],
      searchForm: {
        qy: [],
        qy2: '',
        accountants: [], // 负责人数组
        accountants2: [], // 负责人数组
        taxNature: '', // 纳税性质
        area1: '', // 省或直辖市
        area2: '',
        area3: '',
        name: '', // 客户名称
        legalPerson: '', // 法人
        accountManagerId: '', // 客户经理id
        lastFewDays: '', // 服务到期天数
        deadline: [],
        deadlineA: '',
        deadlineB: '',
        currentPage: 1,
        pageSize: 100,
        total: 0
      },
      companys: [],
      accountants: [], // 负责人数组
      accountants2: [], // 负责人数组
      addForm: {
        name: '', // 公司名称
        simpleName: '', // 公司简称
        qy: '', // 区域
        area1: '',
        area2: '',
        area3: '',
        address: '', // 地址
        legalPerson: '', // 法人
        lxr: '', // 联系人
        lxdh: '', // 联系电话
        taxNature: '', // 纳税性质
        payType: '', // 计费周期
        payType2: '', // 计费周期
        payTime: [], // 计费时间
        payPeriodStart: '',
        payPeriodEnd: '',
        payPeriodStart2: new Date(),
        payPeriodEnd2: new Date(),
        payPeriodStart3: '',
        payPeriodEnd3: '',
        accountManagerId: '', // 客户经理
        accountManager: '',
        accountant: '', // 负责人
        remark: '', // 备注
        picJdcmp: '',
        picJdcmp2: ''
      },
      taxs: [
        { roleId: '小规模', roleName: '小规模' },
        { roleId: '一般纳税人', roleName: '一般纳税人' }
      ],
      persons: [],
      cycle2: [
        { code: 0, name: '到期' },
        { code: '30', name: '30天' },
        { code: '60', name: '60天' },
        { code: '90', name: '90天' },
        { code: '120', name: '120天' },
        { code: '180', name: '180天' }
      ],
      cycle: [
        { roleId: '月付', roleName: '月付' },
        { roleId: '季付', roleName: '季付' },
        { roleId: '半年付', roleName: '半年付' },
        { roleId: '年付', roleName: '年付' }
      ],
      options: cityData,
      options1: [],
      options2: [],
      options3: [],
      popup1ShowState: false,
      popup2ShowState: false,
      popup3ShowState: false,
      fileList: [],
      amount: 0
    }
  },
  methods: {
    querySearch(queryString, cb) {
      var companys = this.companys
      var results = queryString ? companys.filter(this.createFilter(queryString)) : companys
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return restaurant => {
        return restaurant.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    handleSelect(item) {
      console.log(item)
      this.searchForm.name = item
    },
    deadlineChange(val) {
      if (val) {
        this.searchForm.deadlineA = val[0]
        this.searchForm.deadlineB = val[1]
      } else {
        this.searchForm.deadlineA = ''
        this.searchForm.deadlineB = ''
      }
      setTimeout(() => {
        this.search(1)
      }, 50)
    },
    deadlineAchange(val) {
      if (this.searchForm.deadlineB && val > this.searchForm.deadlineB) {
        this.searchForm.deadlineA = ''
        return this.$root.$children[0].vueAlert({ message: '开始时间不能大于结束时间！', type: 'error' })
      }
      setTimeout(() => {
        this.search(1)
      }, 50)
    },
    deadlineBchange(val) {
      if (this.searchForm.deadlineA && val < this.searchForm.deadlineA) {
        this.searchForm.deadlineB = ''
        return this.$root.$children[0].vueAlert({ message: '结束时间不能小于开始时间！', type: 'error' })
      }
      setTimeout(() => {
        this.search(1)
      }, 50)
    },
    reset() {
      this.searchForm = {
        qy: [],
        qy2: '',
        accountants: [], // 负责人数组
        accountants2: [], // 负责人数组
        taxNature: '', // 纳税性质
        area1: '', // 省或直辖市
        area2: '',
        area3: '',
        name: '', // 客户名称
        legalPerson: '', // 法人
        accountManagerId: '', // 客户经理id
        lastFewDays: '', // 服务到期天数
        deadline: [],
        deadlineA: '',
        deadlineB: '',
        currentPage: 1,
        pageSize: 100,
        total: 0
      }
      this.accountants = []
      this.search(1)
    },
    titleClick(item, index) {
      console.log(item, index)
      if (item === '客户中心') {
        this.web = 'main'
        this.titles = ['客户中心'] // 导航菜单
      }
    },
    cellClick(row, column, cell, event) {
      if (column.label !== '操作') {
        this.handleDetail(column.index, row.customer)
      }
    },
    pickerConfirm1(value, index) {
      if (value.value !== this.searchForm.area1) {
        this.searchForm.area2 = ''
        this.searchForm.area3 = ''
      }
      this.searchForm.area1 = value.value
      this.popup1ShowState = false
      const city = this.options[index].children
      this.options2 = []
      for (let i = 0; i < city.length; i++) {
        this.options2.push({
          label: city[i].label,
          text: city[i].text,
          value: city[i].value,
          city: city[i].children
        })
      }
      this.search(1)
    },
    pickerCancel1() {
      this.searchForm.qy = []
      this.searchForm.area1 = ''
      this.popup1ShowState = false
      this.search(1)
    },
    pickerConfirm2(value, index) {
      console.log(value)
      if (value.value !== this.searchForm.area2) {
        this.searchForm.area3 = ''
      }
      this.searchForm.area2 = value.value
      const city = value.city
      this.options3 = []
      for (let i = 0; i < city.length; i++) {
        this.options3.push({
          label: city[i].label,
          text: city[i].text,
          value: city[i].value
        })
      }
      this.popup2ShowState = false
      this.search(1)
    },
    pickerCancel2() {
      this.searchForm.qy = []
      this.searchForm.area2 = ''
      this.popup2ShowState = false
      this.search(1)
    },
    pickerConfirm3(value, index) {
      console.log(value)
      this.searchForm.area3 = value.value
      this.searchForm.qy = [this.searchForm.area1, this.searchForm.area2, this.searchForm.area3]
      this.popup3ShowState = false
      this.search(1)
    },
    pickerCancel3() {
      this.searchForm.qy = []
      this.searchForm.area3 = ''
      this.popup3ShowState = false
      this.search(1)
    },
    // 获取所有员工
    queryUserIdName() {
      const param = {}
      this.$get('/user/queryUserIdName', param).then(
        result => {
          if (result.status === 200) {
            this.persons = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    queryList() {
      if (this.searchForm.deadlineA && !this.searchForm.deadlineB) {
        return this.$root.$children[0].vueAlert({ message: '请选择结束时间！', type: 'error' })
      }
      if (!this.searchForm.deadlineA && this.searchForm.deadlineB) {
        return this.$root.$children[0].vueAlert({ message: '请选择开始时间！', type: 'error' })
      }
      this.searchForm.deadline = [this.searchForm.deadlineA, this.searchForm.deadlineB]
      // 查询用户列表
      let hadAssigned = '1'
      if (this.searchForm.accountants[0] === 'no') {
        hadAssigned = '0'
      }
      if (this.accountants[0] === 'no') {
        this.accountants = []
      }
      const param = {
        accountants: this.accountants,
        taxNature: this.searchForm.taxNature,
        area1: this.searchForm.area1,
        area2: this.searchForm.area2,
        area3: this.searchForm.area3,
        name: this.searchForm.name,
        legalPerson: this.searchForm.legalPerson,
        accountManagerId: this.searchForm.accountManagerId,
        lastFewDays: this.searchForm.lastFewDays,
        deadlineA: this.searchForm.deadlineA,
        deadlineB: this.searchForm.deadlineB,
        hadAssigned: hadAssigned,
        page: this.searchForm.currentPage,
        limit: this.searchForm.pageSize
      }
      this.$common.session.set('customer-search', this.searchForm)
      this.$post('/customer/query', param).then(
        result => {
          if (result.status === 200) {
            this.searchForm.total = result.count
            this.tableData = result.data
            this.amount = 0
            let amount = 0
            for (let i = 0; i < this.tableData.length; i++) {
              for (let j = 0; j < this.tableData[i].feeList.length; j++) {
                const price = this.tableData[i].feeList[j].price
                if (typeof price === 'number') {
                  console.log(price)
                  amount += parseInt(price * 100)
                }
                this.amount = amount / 100
              }
            }
            console.log(amount)
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    exportCustomer() {
      // 查询用户列表
      let hadAssigned = '1'
      if (this.searchForm.accountants[0] === 'no') {
        hadAssigned = '0'
      }
      const param = {
        accountants: this.accountants,
        taxNature: this.searchForm.taxNature,
        area1: this.searchForm.area1,
        area2: this.searchForm.area2,
        area3: this.searchForm.area3,
        name: this.searchForm.name,
        legalPerson: this.searchForm.legalPerson,
        accountManagerId: this.searchForm.accountManagerId,
        deadlineA: this.searchForm.deadlineA,
        deadlineB: this.searchForm.deadlineB,
        lastFewDays: this.searchForm.lastFewDays,
        hadAssigned: hadAssigned
      }
      this.$post('/excel/exportCustomer', param).then(
        result => {
          if (result.status === 200) {
            window.open(result.data, 'target')
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 每页条数切换
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.searchForm.pageSize = val
      this.search()
    },
    // 页码切换
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.searchForm.currentPage = val
      this.search()
    },
    // 查询
    search(currentPage) {
      if (currentPage) {
        this.searchForm.currentPage = currentPage
      }
      // 查询
      this.queryList()
    },
    // 客户新增点击
    add() {
      this.$router.push({
        name: 'CustomerDetail',
        params: {
          id: null,
          webState: 'add'
        }
      })
    },
    // 客户编辑
    handleEdit(index, row) {
      this.$router.push({
        name: 'CustomerDetail',
        params: {
          id: row.id,
          webState: 'edit'
        }
      })
    },
    // 客户详情
    handleDetail(index, row) {
      this.$router.push({
        name: 'CustomerDetail',
        params: {
          id: row.id,
          webState: 'detail'
        }
      })
    },
    // 删除客户
    handleDelete(index, row) {
      this.$root.$children[0].vueConfirm(
        { message: '确认要删除此客户吗?' },
        () => {
          const param = {
            id: row.id
          }
          this.$get('/customer/delete', param).then(
            result => {
              if (result.status === 200) {
                this.search()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        },
        () => {
          return console.log('取消删除')
        }
      )
    },
    // 新增保存
    save(name) {
      this.web = 'main'
      this.titles = ['客户中心']
      this.search()
    },
    // 返回列表
    cancel(state) {
      if (state === 'detail') {
        if (this.addForm.id) {
          this.titles = ['客户中心', '编辑客户']
          this.web = 'edit'
        } else {
          this.titles = ['客户中心', '新增客户']
          this.web = 'add'
        }
      } else {
        this.web = 'main'
        this.titles = ['客户中心']
        this.$emit('cancel')
      }
    },
    // 查询 ： 区域更改
    searchQyChange(val) {
      console.log(val)
      if (val) {
        this.searchForm.area1 = val[0]
        this.searchForm.area2 = val[1]
        this.searchForm.area3 = val[2]
      }
      this.search(1)
    },
    // 负责人选择变化
    accountantChange(val) {
      if (val.indexOf('未分配') >= 0) {
        console.log(val)
      }
      this.searchForm.accountants2 = val
      const accountants = []
      for (let i = 0; i < this.persons.length; i++) {
        for (let j = 0; j < val.length; j++) {
          if (this.persons[i].id === val[j]) {
            accountants.push(this.persons[i].id)
          }
        }
      }
      this.accountants = accountants
      setTimeout(() => {
        this.$refs.selectMultiple.blur()
        this.search(1)
      }, 50)
    },
    /**
     * 查询变更项
      system/code/query?systemId=0&businessId=0
      纳税性质
      system/code/query?systemId=0&businessId=1
      计费周期
      system/code/query?systemId=0&businessId=2
      案件状态
      system/code/query?systemId=0&businessId=3
      案件类型
      system/code/query?systemId=0&businessId=4
      案件业务类型
      system/code/query?systemId=0&businessId=5
    */
    queryCode(businessId) {
      const param = {
        systemId: 0,
        businessId: businessId
      }
      this.$get('/system/code/query', param).then(
        result => {
          if (result.status === 200) {
            if (businessId === 0) {
              this.changs = result.data
            } else if (businessId === 1) {
              this.taxs = result.data
            } else if (businessId === 2) {
              this.cycle = result.data
            } else if (businessId === 3) {
              this.states = result.data
            } else if (businessId === 4) {
              this.caseTypes = result.data
            } else if (businessId === 5) {
              this.businessTypes = result.data
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 上传提交
    submitUpload() {
      console.log(this.fileList)
      // this.$refs.upload.submit()
    },
    handleChange(file, fileList) {
      console.log(file, fileList)
      this.fileList = [file]
      const x = (1024 * 1024) / file.size
      const y = Math.sqrt(x)
      console.log(y)
      const base64 = this.common.blobToDataURL(file.raw)
      base64.then(response => {
        this.common.dataURLtoImg(response).then(img => {
          console.log(img)
          this.compressImg(img, 'image/png', y).then(file => {
            console.log(file)
            this.common.blobToDataURL(file).then(base64 => {
              console.log(base64)
            })
          })
        })
      })
    },
    // 移除选择文件
    handleRemove(file, fileList) {
      this.fileList = fileList
      console.log(file, fileList)
    },
    // 预览
    handlePreview(file) {
      console.log(file)
    },
    // 压缩前将file转换成img对象
    readImg(file) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        const reader = new FileReader()
        reader.onload = function(e) {
          img.src = e.target.result
        }
        reader.onerror = function(e) {
          reject(e)
        }
        reader.readAsDataURL(file)
        img.onload = function() {
          resolve(img)
        }
        img.onerror = function(e) {
          reject(e)
        }
      })
    },
    /**
     * 压缩图片
     *@param img 被压缩的img对象
     * @param type 压缩后转换的文件类型
     * @param ratio 触发压缩的图片 倍率 < 1 压缩
     */
    compressImg(img, type, ratio) {
      return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        const { width: originWidth, height: originHeight } = img
        // 目标尺寸
        let targetWidth = originWidth
        let targetHeight = originHeight
        if (ratio < 1) {
          targetWidth = targetWidth * ratio
          targetHeight = targetHeight * ratio
        }
        canvas.width = targetWidth
        canvas.height = targetHeight
        context.clearRect(0, 0, targetWidth, targetHeight)
        // 图片绘制
        context.drawImage(img, 0, 0, targetWidth, targetHeight)
        canvas.toBlob(function(blob) {
          resolve(blob)
        }, type || 'image/png')
      })
    },
    async upload(file) {
      const img = await this.readImg(file)
      const blob = await this.compressImg(img, file.type, 1000, 1000)
      const formData = new FormData()
      formData.append('file', blob, 'xxx.jpg')
    },
    downloadExcel() {
      // const a = document.createElement('a') // 生成一个a元素
      // const event = new MouseEvent('click') // 创建一个单击事件
      // a.download = '批量导入客户模板' // 设置图片名称
      // a.href =
      //   'https://wechat.suzhougs.com/acms-files/批量导入客户模板.xlsx' // 将生成的URL设置为a.href属性
      // a.target = '_blank'
      // a.dispatchEvent(event) // 触发a的单击事件
      window.open('https://17l.link/acms-files/批量导入客户模板.xlsx', 'target')
    },
    fileRead(e) {
      const file = e.target.files[0]
      console.log(e.target.files[0])
      if (file.name.toLowerCase().indexOf('xls') === -1 || file.name.toLowerCase().indexOf('xlsx') === -1) {
        this.$message.error('只能上传.XLS、.XLSX格式的文件!')
        this.$refs[e.target.name].value = ''
        return false
      }
      this.$refs[e.target.name].value = ''
      if (file) {
        this.importExcel(file)
      }
    },
    importExcel(file) {
      const param = new FormData()
      param.append('excel', file)
      this.$formData('/excel/importCustomer', param).then(
        result => {
          if (result.status === 200) {
            this.search(1)
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询公司（客户）
    queryCustomerByCid() {
      const param = {
        cid: this.userInfo.cid
      }
      this.$get('/case/queryCompanyNameList', param).then(
        result => {
          if (result.status === 200) {
            this.companys = result.data
          } else {
            this.$dialog.alert({
              message: result.msg
            })
          }
        },
        error => {
          this.$dialog.alert({
            message: error.name + ':' + error.message
          })
        }
      )
    }
  },
  mounted() {
    if (this.$common.session.get('userInfo')) {
      this.userInfo = this.$common.session.get('userInfo')
      if (this.userInfo.id === 70) {
        this.$root.$children[0].sign('http://17l.link/dist/?id=1&targetName=experience&wechatLogin=true&state=123')
      } else {
        this.$root.$children[0].sign('http://17l.link/dist/?id=1&targetName=Customer&wechatLogin=true&state=123')
      }
    } else {
      var ua = window.navigator.userAgent.toLowerCase()
      // 通过正则表达式匹配broser 中是否含有MicroMessenger字符串
      // eslint-disable-next-line eqeqeq
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        window.location.href = 'http://17l.link/dist/?id=1&targetName=Customer&wechatLogin=true&state=123'
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
      return
    }
    if (this.$common.session.get('customer-search')) {
      this.searchForm = this.$common.session.get('customer-search')
      this.searchForm.area1 = this.searchForm.qy[0] ? this.searchForm.qy[0] : ''
      this.searchForm.area2 = this.searchForm.qy[1] ? this.searchForm.qy[1] : ''
      this.searchForm.area3 = this.searchForm.qy[2] ? this.searchForm.qy[2] : ''
      this.accountants = this.searchForm.accountants
    }
    for (let i = 0; i < this.options.length; i++) {
      this.options1.push({
        label: this.options[i].label,
        text: this.options[i].text,
        value: this.options[i].value
      })
    }
    // this.queryCustomerByCid()
    this.queryUserIdName() // 查询公司所属员工
    if (this.userInfo.content_jurisdiction === '0') {
      this.searchForm.accountants = [this.userInfo.id]
    }
    this.queryList() // 列表查询
    this.queryCode(1)
    this.queryCode(2)
    // this.searchForm.qy = []
    // this.searchForm.area1 = ''
    // this.searchForm.area2 = ''
    // this.searchForm.area3 = ''
    if (this.searchForm.area1) {
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].text === this.searchForm.area1) {
          const index = i
          const vals = this.options[i]
          vals.city = vals.children
          this.pickerConfirm1(vals, index)
          if (this.searchForm.area2) {
            for (let j = 0; j < vals.children.length; j++) {
              if (vals.children[j].text === this.searchForm.area2) {
                const index2 = j
                const vals2 = vals.children[j]
                vals2.city = vals2.children
                this.pickerConfirm2(vals2, index2)
                if (this.searchForm.area3) {
                  for (let k = 0; k < vals2.children.length; k++) {
                    if (vals2.children[k].text === this.searchForm.area3) {
                      const index3 = k
                      const vals3 = vals2.children[k]
                      this.pickerConfirm3(vals3, index3)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    this.$nextTick(() => {
      // this.$refs.picker.setValues(this.searchForm.qy)
    })
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped>
.show-phone {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
    .el-input__prefix {
      height: 34px;
    }
  }
}
.el-autocomplete-suggestion.el-popper {
  width: 300px !important;
}
.import-btn {
  position: relative;
  .import-excel {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    left: 0;
    top: 0;
  }
}
.edit-page,
.main-page {
  height: 100%;
}
.img-box {
  position: relative;
  display: inline-flex;
  width: 10vh;
  height: 10vh;
  margin-right: 5vh;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    max-width: 100%;
    max-height: 10vh;
    min-height: 10vh;
  }
  .upload {
    display: inline-flex;
    position: relative;
    width: 5vh;
    height: 5vh;
    color: #ccc;
    border: 2px solid #ccc;
    font-size: 3vw;
    line-height: 0;
    align-items: center;
    justify-content: center;
    vertical-align: text-bottom;
    cursor: pointer;
    .upload-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 5vh;
      height: 5vh;
      opacity: 0;
      cursor: pointer;
      background: transparent;
    }
  }
  .mask {
    display: flex;
    position: relative;
    width: 10vh;
    height: 10vh;
    color: #ccc;
    background: rgba(0, 0, 0, 0.5);
    font-size: 2.15rem;
    line-height: 0;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .mask-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      background: transparent;
      z-index: 1000;
    }
    .el-icon-plus {
      font-size: 1.2rem;
      font-weight: bold;
      color: #fff;
      height: 1.2rem;
      line-height: 1;
    }
    .text {
      font-size: 1.2rem;
      font-weight: bold;
      color: #fff;
      height: 1.2rem;
      line-height: 1;
    }
  }
}
</style>
